import { elementHasScrollX, elementHasScrollY } from '../../utils/dom.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var PendoScrollIndicator = {
  name: 'PendoScrollIndicator',
  props: {
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      canScroll: {
        up: false,
        down: false,
        left: false,
        right: false
      }
    };
  },
  watch: {
    disabled: _async(function () {
      const _this = this;
      return _await(_this.$nextTick(), function () {
        _this.setupObservers();
      });
    })
  },
  mounted() {
    this.setupObservers();
  },
  methods: {
    setupObservers() {
      if (this.disabled) {
        return;
      }
      if (!this.resizeObserver) {
        this.resizeObserver = new ResizeObserver(this.toggleIndicators);
        this.$once('hook:beforeDestroy', () => this.resizeObserver.disconnect());
      }
      this.resizeObserver.observe(this.$refs.content);
      if (!this.mutationObserver) {
        this.mutationObserver = new MutationObserver(this.toggleIndicators);
        this.$once('hook:beforeDestroy', () => this.mutationObserver.disconnect());
      }
      this.mutationObserver.observe(this.$refs.content, {
        childList: true,
        attributes: false
      });
    },
    toggleIndicators() {
      const contentRef = this.$refs.content;
      if (!contentRef) {
        return;
      }
      const hasHorizontalScrollbar = elementHasScrollX(contentRef);
      const hasVerticalScrollbar = elementHasScrollY(contentRef);
      const isScrolledToTopEdge = contentRef.scrollTop === 0;
      const isScrolledToLeftEdge = contentRef.scrollLeft === 0;
      const isScrolledToRightEdge = contentRef.scrollWidth - contentRef.scrollLeft - contentRef.offsetWidth < 1;
      const isScrolledToBottomEdge = contentRef.scrollHeight - contentRef.scrollTop - contentRef.offsetHeight < 1;
      this.canScroll.up = hasVerticalScrollbar && !isScrolledToTopEdge;
      this.canScroll.down = hasVerticalScrollbar && !isScrolledToBottomEdge;
      this.canScroll.right = hasHorizontalScrollbar && !isScrolledToRightEdge;
      this.canScroll.left = hasHorizontalScrollbar && !isScrolledToLeftEdge;
    }
  },
  render(createElement) {
    if (this.disabled) {
      const nodes = this.$scopedSlots && this.$scopedSlots.default();
      if (!nodes) {
        return createElement();
      }
      if (nodes.length < 2 && !nodes[0].text) {
        return nodes;
      }
      return createElement('div', nodes);
    }
    const renderIndicators = () => {
      if (this.$scopedSlots.indicators) {
        return this.$scopedSlots.indicators({
          canScroll: this.canScroll
        });
      }
      return ['up', 'down', 'left', 'right'].map(direction => {
        return createElement('div', {
          class: ['pendo-scroll-indicator__shadow', `pendo-scroll-indicator__shadow--${direction}`, {
            'is-active': this.canScroll[direction]
          }]
        });
      });
    };
    return createElement('div', {
      class: 'pendo-scroll-indicator'
    }, [createElement('div', {
      class: 'pendo-scroll-indicator__content',
      ref: 'content',
      on: {
        '&scroll': this.toggleIndicators
      }
    }, [this.$slots.default, renderIndicators()])]);
  }
};

export { PendoScrollIndicator as default };
//# sourceMappingURL=pendo-scroll-indicator.js.map
